"use strict";
angular.module("showBigPictureModule", [])
    .controller("showBigPictureCtrl", ["$scope", "$rootScope", "$modalInstance", "localStorageService", "$sce", "trsHttpService", "modalDialog", "$timeout", "$compile", "commandService", "$q","datas", "$validation", "$filter","$element",
        function($scope, $rootScope, $modalInstance, localStorageService, $sce, trsHttpService, modalDialog, $timeout, $compile, commandService , $q,datas, $validation,$filter, $element) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化数据
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status={
                    isLeftDisabled:parseInt(datas.index)<=0,
                    isRightDisabled:parseInt(datas.index)>=(datas.picDatas.length-1),
                };
               $scope.data={
                   picIndex:parseInt(datas.index),
                   picDatas:datas.picDatas
               }
            }
            /**
             * [initData description] 初始化新建数据
             * @return {[type]} [description]
             */
            function initData() {
                $scope.data.imgUrl=$scope.data.picDatas[$scope.data.picIndex];

            }
            $scope.viewToLeft=function(){
               $scope.data.picIndex--;
                if($scope.data.picIndex<=0){
                    $scope.status.isLeftDisabled=true;
                    $scope.status.isRightDisabled=false;
                }
                $scope.data.imgUrl=$scope.data.picDatas[$scope.data.picIndex];
            };
            $scope.viewToRight=function(){
                $scope.data.picIndex++;
                if($scope.data.picIndex>=$scope.data.picDatas.length-1){
                    $scope.status.isRightDisabled=true;
                    $scope.status.isLeftDisabled=false;
                }
                $scope.data.imgUrl=$scope.data.picDatas[$scope.data.picIndex];
            };
            /**
             * [close description] 关闭弹框
             * @return {[type]} [description]
             */
            $scope.close = function() {
                $modalInstance.dismiss();
            };


        }
    ]);